<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1"> </p>
<p class="TPHT"><span class="ePub-B"><a id="pg_xi">Constitutional Calculu</a><a id="pg_xii">s</a></span></p><a id="pg_xii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?c218fe98